import Aparecer from './Aparecer';
import Recolher from './Recolher';
import type { DespesasResumo } from '@/pages/gerenciar/painel/financeiro/relatorio/types';
import { formatarCentavos } from '@/pages/loja/utils';

export default function SecaoDespesas({ d }: { d: DespesasResumo }) {
  return (
    <Aparecer>
      <section className="rel-secao rounded-2xl border border-background-200 bg-white p-4 shadow-[0_1px_3px_rgba(16,24,40,0.04)] md:p-5">
        <div className="flex flex-wrap items-baseline justify-between gap-x-3">
          <h2 className="text-[15px] font-bold text-foreground-950">Despesas</h2>
          <span className="text-[17px] font-extrabold tabular-nums text-foreground-950">
            {formatarCentavos(d.total_centavos)}
          </span>
        </div>
        <p className="mt-1 text-[12px] text-foreground-500">
          {d.quantidade} {d.quantidade === 1 ? 'despesa' : 'despesas'}
          {d.sem_comprovante > 0 && (
            <>
              {' · '}
              <span className="font-medium text-warning-700">
                {d.sem_comprovante} sem comprovante
              </span>
            </>
          )}
        </p>

        {d.por_categoria.length > 0 && (
          <Recolher rotulo="Ver por categoria">
            <ul className="space-y-2">
              {d.por_categoria.map((c, i) => (
                <li key={i} className="flex items-center justify-between gap-2 text-[13px]">
                  <span className="truncate text-foreground-800">{c.categoria}</span>
                  <span className="shrink-0 font-semibold tabular-nums text-foreground-900">
                    {formatarCentavos(c.total_centavos)}
                  </span>
                </li>
              ))}
            </ul>
          </Recolher>
        )}
      </section>
    </Aparecer>
  );
}